Ext.define('SA.BadgedAttributeLabel', {
    singleton: true,

    getHtml({attribute, ...badgesCfg}) {
        var {name, year} = SA.data.AttributesCache.get(attribute);

        return SA.Tags.html`${name}, ${year} ` + SA.AttributeBadges.getHtml({attribute, ...badgesCfg});
    },

    getText({attribute}) {
        var {name, year} = SA.data.AttributesCache.get(attribute);

        return `${name}, ${year}${SA.AttributeBadges.getText({attribute})}`;
    }
});